import React, { useEffect } from "react";

import MasterDepositoryTable from "./MasterDepositoryTable";
import MasterDepositoryAdd from "./MasterDepositoryAdd";
import MasterDepositoryEdit from "./MasterDepositoryEdit";

import useApiNew from "../../../utils/useApiNew";
import axios from "axios";

import Breadcrumbs from "../../../components/ui/Breadcrumbs";

import DeleteAlert from "../../../components/ui/DeleteAlert";

import { errorNotify, successNotify } from "../../../Services/Notification";
import { actionPermissions } from "../../../components/authNavigation/AuthNavbar";

const depositoryApiURL = `${process.env.REACT_APP_API_URL}api/depository`;
const exportDepositoryApiURL = `${process.env.REACT_APP_API_URL}api/export-depository`;

const MasterDepository = () => {
  const [renderKey, setRenderKey] = React.useState(0);
  const [isAdd, setIsAdd] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [isDelete, setIsDelete] = React.useState(false);
  const [selectedItemId, setSelectedItemId] = React.useState();
  const [globalFilters, setGlobalFilters] = React.useState("");
  const [despositData, setdespositData] = React.useState();
  const [isButtonClicked, setIsButtonClicked] = React.useState();
  const [isDownloadClicked, setIsDownloadClicked] = React.useState();

  const triggerRerender = () => {
    setRenderKey((prevKey) => prevKey + 1);
  };

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };
  const name = "depository";

  let { data, loading } = useApiNew(
    depositoryApiURL,
    "GET",
    { headers },
    renderKey,
  );

  // GET ONE

  data = data?.map((item) => ({
    ...item,
    status: item.status ? "Active" : "Inactive",
  }));

  const handleGetOneSecurity = async (id) => {
    const getOneAPI = `${depositoryApiURL}/${id}`;

    try {
      const res = await axios.get(getOneAPI, { headers });
      const resData = res.data.data;

      triggerRerender();

      if (!resData.error) return resData;
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const filterBankData = () => {
    let filterData = data;
    if (globalFilters) {
      filterData = data.filter(
        (item) =>
          item?.name?.toLowerCase().includes(globalFilters?.toLowerCase()) ||
          item?.short_name
            ?.toLowerCase()
            .includes(globalFilters?.toLowerCase()) ||
          item?.status?.toLowerCase() === globalFilters?.toLowerCase() ||
          item?.dep_code?.toLowerCase().includes(globalFilters?.toLowerCase()),
      );
    }
    setdespositData(filterData);
  };
  useEffect(() => {
    filterBankData();
  }, [globalFilters]);

  // ADD

  const handleAddBank = async (data) => {
    setIsButtonClicked(true);
    try {
      const res = await axios.post(depositoryApiURL, data, { headers });
      const resData = res.data;

      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // EDIT

  const handleEditBank = async (segmentId, data) => {
    setIsButtonClicked(true);
    const updateAPI = `${depositoryApiURL}/${segmentId}`;

    try {
      const res = await axios.put(updateAPI, data, { headers });
      const resData = res.data;
      triggerRerender();

      if (!resData.error) {
        successNotify("Data saved.");
        setIsButtonClicked(false);
        return true;
      } else {
        errorNotify(resData?.message);
        setIsButtonClicked(false);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      setIsButtonClicked(false);
      return false;
    }
  };

  // DELETE

  const handleDeleteBank = async () => {
    const deleteAPI = `${depositoryApiURL}/${selectedItemId}`;
    try {
      const res = await axios.delete(deleteAPI, { headers });
      const resData = res.data;
      triggerRerender();
      if (!resData.error) {
        successNotify("Data deleted.");
        setIsDelete(false);
        return true;
      } else {
        errorNotify(resData?.message);
      }
    } catch (err) {
      console.error(err);
      errorNotify("Something went wrong.");
      return false;
    }
  };

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().slice(0, 10);

  const downloadExcel = async (filename) => {
    try {
      const apiEndpoint = exportDepositoryApiURL;
      const headers = {
        Authorization: `Bearer ${
          sessionStorage.getItem("subscriberToken")
            ? sessionStorage.getItem("subscriberToken")
            : sessionStorage.getItem("token")
        }`,
      };
      const response = await axios.get(apiEndpoint, {
        headers,
        responseType: "blob",
      });

      if (response && response.data) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename; // Set the filename here

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        setIsDownloadClicked(false);
      } else {
        console.error("Invalid response or missing data");
        setIsDownloadClicked(false);
      }
    } catch (error) {
      errorNotify("Something went wrong.");
      setIsDownloadClicked(false);
    }
  };

  // download
  const downloadDepository = () => {
    setIsDownloadClicked(true);
    const filename = `Depository-Master_${formattedDate}.xlsx`;
    downloadExcel(filename);
  };

  const breadcrumbs = ["Home", "Master", "Demat"];

  const buttonConfig = {
    value: "demat",
    name: "Dank",
    getOneHandler: handleGetOneSecurity,
    addHandler: handleAddBank,
    editHandler: handleEditBank,
    deleteHandler: handleDeleteBank,
    downloadHandler: downloadDepository,
    closeAddModal: () => setIsAdd(false),
    closeEditModal: () => setIsEdit(false),
  };

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />
      <MasterDepositoryTable
        tableData={globalFilters ? despositData : data}
        buttonConfig={buttonConfig}
        setIsAdd={setIsAdd}
        setIsEdit={setIsEdit}
        setIsDelete={setIsDelete}
        setSelectedItemId={setSelectedItemId}
        renderKey={renderKey}
        setGlobalFilters={setGlobalFilters}
        loading={loading}
        isDownloadClicked={isDownloadClicked}
        actionPermissions={actionPermissions("masters", "Depository")}
      />
      {isAdd && (
        <MasterDepositoryAdd
          buttonConfig={buttonConfig}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isEdit && (
        <MasterDepositoryEdit
          buttonConfig={buttonConfig}
          selectedItemId={selectedItemId}
          isButtonClicked={isButtonClicked}
        />
      )}
      {isDelete && (
        <DeleteAlert
          closeHandler={() => setIsDelete(false)}
          deleteHandler={buttonConfig.deleteHandler}
        />
      )}
    </div>
  );
};

export default MasterDepository;
